import { SeoHead } from "@/components/SeoHead"
import { ReportExitHeader } from "./components/ReportExitHeader"
import { useEffect } from "react"
import { router } from "@inertiajs/react"

const POLL_INTERVAL_MS = 5000

export default function ReportPreparing({ seo, publicToken, currentUser = null }) {
  useEffect(() => {
    const id = setInterval(() => {
      router.reload({ preserveScroll: true })
    }, POLL_INTERVAL_MS)
    return () => clearInterval(id)
  }, [publicToken])

  return (
    <>
      <SeoHead seo={{ ...seo, noIndex: true }} />
      <ReportExitHeader currentUser={currentUser} />
      <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
        <div className="max-w-lg w-full text-center space-y-6">
          <div className="flex justify-center">
            <div className="relative">
              <div className="w-16 h-16 rounded-full border-4 border-zinc-200" />
              <div className="absolute inset-0 w-16 h-16 rounded-full border-4 border-transparent border-t-kf-red animate-spin" />
            </div>
          </div>
          <h1 className="font-display text-2xl">
            Your report is being prepared
          </h1>
          <p className="text-zinc-600">
            This usually takes 1–2 minutes. You can wait here and the page
            will refresh itself, or close the tab and check your email in a
            couple minutes — we send the full report there too.
          </p>
        </div>
      </div>
    </>
  )
}
